import { CsvSeparator, DateTimeFormatRepository } from "consts/general";
import { convertToFormData } from "util/transformers";
import { formatDate } from "util/formaters";
import { useSimpleRequest } from "hooks";
import { FormAdapter } from "hooks/useForm";
import { postPspSettlements } from "features/merchantPayouts/api";
import { withSx } from "ui/atoms/Modal";
import { BasicDialog } from "ui/molecules/Dialog";
import ActionPanel from "ui/molecules/ActionPanel";
import { UploadSettlement } from 'ui/forms/MerchantPayout';
import useUploadSettlementContext from "./useUploadSettlementContext";

const UploadSettlementDialog = () => {
    const { open, onClose } = useUploadSettlementContext();

    const request = useSimpleRequest();

    const formProps: UploadSettlement.UploadSettlementForm = {
        initialValues: UploadSettlement.getInitialValues({}),
        isBootstrapDataLoading: false,
        bootstrapData: {
            [UploadSettlement.FormField.CsvSeparator]: [
                CsvSeparator.Comma,
                CsvSeparator.Semicolon
            ]
        },
        onSaveOrCreate: async ({ settlementDate, ...values }, helpers) => {
            const response = await request(() => postPspSettlements(
                convertToFormData({
                    ...values,
                    [UploadSettlement.FormField.SettlementDate]: formatDate(settlementDate, {
                        pattern: DateTimeFormatRepository.Default
                    })
                })
            ), {
                onSuccess: () => {
                    helpers!.resetForm();
                    onClose();
                }
            });

            return FormAdapter.fromResponse(response);
        }
    };

    const form = UploadSettlement.useForm(formProps);

    const handleClose = () => {
        form.resetForm();
        onClose();
    };

    return (
        <BasicDialog
            isOpen={open}
            onClose={handleClose}
            titleSlot='Upload Settlement'
            disableCloseOnBackdropClick
            DialogProps={withSx({
                maxWidth: 'sm',
                width: '100%'
            })}
        >
            <UploadSettlement.Form
                {...formProps}
                {...form}
            >
                <ActionPanel
                    onCancel={handleClose}
                    onSave={async () => { }}
                    SaveActionProps={{
                        type: 'submit',
                        children: 'Upload',
                        disabled: !form.isValid,
                        loading: form.isSubmitting
                    }}
                />
            </UploadSettlement.Form>
        </BasicDialog>
    );
};

export default UploadSettlementDialog;
